import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { useMembranesApi } from "../../../../../http/patrol/useMembranes";
import FlexContent from "../../../../ui/FlexContent";
import Header from "../../../../ui/Header";
import { PATROL } from "../../AdminSystemSettings";
import MembraneForm from "./MembraneForm";

const Membrane: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { membraneId } = useParams<{ membraneId: string }>();
  const membranesApi = useMembranesApi();

  const aborter = useRef(new AbortController());
  const { error, data, isMutating, trigger } = membranesApi.getAdminMembrane(aborter.current.signal);

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: PATROL },
    {
      url: `/admin/systems/${systemId}/settings?tab=2&r_t=4`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.membranes.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    membraneId && trigger(membraneId);
  }, [membraneId]);

  return (
    <>
      <Header title={`${i18n.translation.membranes.singular}: ${data?.name ?? ""}`} error={error} path={path} />
      <FlexContent padding direction="row">
        <MembraneForm membrane={!error ? data : undefined} disabled={isMutating || !!error} />
      </FlexContent>
    </>
  );
};

export default Membrane;
